"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const lodash_1 = require("lodash");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const notification_1 = __importDefault(require("../../constants/notification"));
const CancelReviewModal = (props) => {
    const { handleClose, isOpen, round = { id: 0, title: '' } } = props;
    const handleCancelClick = () => {
        utilities_1.default.blockPage();
        pulse_components_1.v2Endpoint
            .delete(`/v2/api/rounds/${round.id}`)
            .then((res) => {
            const { data, status } = res;
            if (status === 200) {
                utilities_1.default.notification.success(notification_1.default.deletedRound);
                utilities_1.default.unblockPage();
                if (window.location.hash) {
                    const roundNumber = window.location.hash.split('-')[1];
                    if (Number(roundNumber) - 1 > 0) {
                        const hash = `${window.location.hash.split('-')[0]}-${Number(roundNumber) - 1}`;
                        window.location.hash = hash;
                    }
                    else {
                        window.location.hash = '';
                    }
                }
                window.location.reload();
                if ((0, lodash_1.isFunction)(handleClose))
                    handleClose();
            }
        })
            .catch((error) => {
            utilities_1.default.notification.danger(error);
            utilities_1.default.unblockPage();
        });
    };
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { variant: "jqconfirm", headerIconClasses: 'fal fa-times-circle', PulseModalHeaderProps: {
            onCloseClick: handleClose,
            primaryText: 'CANCEL ROUND',
            classes: {
                root: 'header-root',
                closeBtn: 'header-root__close-btn',
            },
        }, classes: {
            dialog: {
                paper: styles_modules_less_1.default['review-modal__root'],
            },
        }, footer: false, open: isOpen, onModalClose: handleClose },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['cancel-review-modal'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['cancel-review-modal__content'] },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['primary-text'] }, "You are about to cancel this Round:"),
                react_1.default.createElement("div", { className: styles_modules_less_1.default['secondary-text'] },
                    react_1.default.createElement("div", null, round.title)),
                react_1.default.createElement("div", { className: styles_modules_less_1.default['confirm-text'] }, "Do you wish to proceed?")),
            react_1.default.createElement("div", { className: styles_modules_less_1.default['cancel-review-modal__buttonCtn'] },
                react_1.default.createElement(pulse_components_1.PulseButton, { classes: [
                        (0, clsx_1.default)(styles_modules_less_1.default['cancel-review-modal__button'], styles_modules_less_1.default['cancel-review-modal__button--cancel']),
                    ], label: 'Cancel', onClick: handleClose }),
                react_1.default.createElement(pulse_components_1.PulseButton, { classes: [
                        (0, clsx_1.default)(styles_modules_less_1.default['cancel-review-modal__button'], styles_modules_less_1.default['cancel-review-modal__button--cancel-review']),
                    ], icon: true, iconClasses: {
                        icon: (0, clsx_1.default)('fal fa-times-circle', styles_modules_less_1.default['cancel-review-modal__icon']),
                    }, color: pulse_components_1.Colors.danger, label: 'CANCEL ROUND', onClick: handleCancelClick })))));
};
exports.default = CancelReviewModal;
